export const getAdjustedOnboardingStep = (step, finished) => {
  if (!finished) return step

  return step + 1
}
